import { Injectable } from '@angular/core';
import { InvoicesService } from '../services/invoices.service';
import { Invoice } from '../../models/invoice';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { BreadcrumbResolver } from '../../breadcrumb/breadcrumb.resolver';

@Injectable()

/**
 * InvoiceResolver resolves request to get an invoice by id
 */
export class InvoiceResolver extends BreadcrumbResolver<Invoice>
{
	/**
	 * InvoiceResolver constructor
	 *
	 * @param {InvoicesService} invoicesService
	 * @param {BreadcrumbService} breadcrumbService
	 */
	constructor(breadcrumbService: BreadcrumbService, private invoicesService: InvoicesService)
	{
		super(breadcrumbService);
	}

	getData(params)
	{
		return this.invoicesService.getInvoice(params['id']);
	}

	getBreadcrumb(data: Invoice)
	{
		return data.number;
	}
}




// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/invoice.resolver.ts